import fetch from '../utils/fetch';
import URLS from '../constants/urls';
export const types = {
    LINK: 'LINK',
    EXTERNAL_LINK: 'EXTERNAL_LINK',
    DISPATCH: 'DISPATCH',
    DISABLED: 'DISABLED'
};

/**
 * Converts Array to string for FormData;
 * @param {array} ids array of ids to send to backend
 */
const getBodyStringFromIDs = ids => {
    let bodyString = '';
    if (ids) {
        ids.forEach((id, pos) => {
            bodyString += `${pos > 0 ? '&' : ''}ids=${id}`;
        });
    }
    return bodyString;
};

/**
 * Headers to be set on 'fetch' requests for FormData
 * We should remove FormData posts
 */
const formHeaders = {
    'X-Requested-With': 'XmlHtpRequest',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Content-Disposition': 'form-data'
};

/**
 * Get Restart Items Summary
 * @param {array} ids
 * @returns {promise} fetch promise returned;
 */
export const restartItemsSummary = ids =>
    fetch(URLS.ACTIVE_ITEMS_RESTART_SUMMARY, {
        body: JSON.stringify({ ids: ids })
    });

/**
 * End Items
 * @param {array} ids 'selectedCheckboxes in state'
 * @returns {promise} fetch promise returned;
 */
export const endItems = ids =>
    fetch(URLS.ACTIVE_END_ITEMS, {
        body: `${getBodyStringFromIDs(ids)}&filter=all`,
        headers: formHeaders
    });

/**
 * Show Items in Purchases list
 * @param {array} ids 'selectedCheckboxes in state'
 * @returns {promise} fetch promise returned;
 */
export const showPurchases = ids =>
    fetch(URLS.BUYER_SHOW, {
        body: `${getBodyStringFromIDs(ids)}&filter=all`,
        headers: formHeaders
    });

/**
 * Show Items
 * @param {array} ids 'selectedCheckboxes in state'
 * @returns {promise} fetch promise returned;
 */
export const showActive = ids =>
    fetch(URLS.BUYER_ACTIVE_ITEMS_SHOW, {
        body: `${getBodyStringFromIDs(ids)}&filter=all`,
        headers: formHeaders
    });

/**
 * Hide Items
 * @param {array} ids 'selectedCheckboxes in state'
 * @returns {promise} fetch promise returned;
 */
export const hideActive = ids =>
    fetch(URLS.BUYER_ACTIVE_ITEMS_HIDE, {
        body: `${getBodyStringFromIDs(ids)}&filter=all`,
        headers: formHeaders
    });

/**
 * Restart Items
 * @param {array} ids 'selectedCheckboxes in state'
 * @returns {promise} fetch promise returned;
 */
export const restartItems = ids =>
    fetch(URLS.UNSOLD_RESTART_ITEMS, {
        body: `${getBodyStringFromIDs(ids)}&filter=all`,
        headers: formHeaders
    });

/**
 * Mark Paid
 * @param {array} ids 'selectedCheckboxes in state'
 * @returns {promise} fetch promise returned;
 */
export const markPaid = ids =>
    fetch(URLS.BUYER_MARK_PAID, {
        body: `${getBodyStringFromIDs(ids)}&filter=all`,
        headers: formHeaders
    });
